var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 64,
    viewBox: "0 0 87 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.7969 11C83 6.60156 79.2031 3.39844 74.7969 2.39844C68.2031 1 56 0 42.7969 0C29.6016 0 17.2031 1 10.6016 2.39844C6.20313 3.39844 2.39844 6.39844 1.60156 11C0.796876 16 0 23 0 32C0 41 0.796876 48 1.79688 53C2.60156 57.3984 6.39844 60.6016 10.7969 61.6016C17.7969 63 29.7969 64 43 64C56.2031 64 68.2031 63 75.2031 61.6016C79.6016 60.6016 83.3984 57.6016 84.2031 53C85 48 86 40.7969 86.2031 32C85.7969 23 84.7969 16 83.7969 11ZM32 46V18L56.3984 32L32 46Z",
    fill: "#163B6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLogo);
export default __webpack_public_path__ + "static/media/YoutubeLogo.b4d6e9de87c23021a4a0b273b6b44311.svg";
export { ForwardRef as ReactComponent };